import React from 'react'
import firebase from 'firebase/compat/app'
import 'firebase/compat/database';
import { Form, Input, Dropdown, Button } from 'semantic-ui-react'
import Styles from './AsignarTrabajo.module.css'
import MultipleFS from '../MultipleFS'
import DateUtilities from '../DateUtilities'
import PointedBar from '../pointedBar/pointedBar'

class AsignarTrabajo extends React.Component {
    constructor(props) {
        super(props)
        this.tareaId = props.id
        this.actividad = props.actividad
        this.state = {
            assignedTask: {
                dificultad:1,
                empleados: [],
                tareaId: '',
                areaAsignada: '',
                estado: 'pendiente',
                longitudTrabajo: 0,
                precioUnitario: 0,
                precioTotal: 0,
                descripcion: props.descripcion || '',
                fechaInicio: '',
                fechaEntrega: '',
                nomina: 'tarea',
                unidad: props.unidad
            },
            precioInicial: 0,
            precioUnaPersona: 0,
            fechaInicioStr: '',
            fechaEntregaStr: '',
            submitDisabled: false,
            completedArea: [],
            requiredArea: [],
            pendingArea: [],
            disabledArea: [],
            subTasksList: [],
            zones: [],
            tuneles: [],
            tunelesMedidas: {},
            assignBy: 'zona',
            mensajes: {
                area: false,
                empleados: false,
                fechaInicio: false,
                fechaEntrega: false,
            },
            zonasAsignadas: 0,
            tunelesAsigadas: 0,
            camasAsignadas: 0,
            zonasAsignadasNew: 0,
            tunelesAsigadasNew: 0,
            camasAsignadasNew: 0,
            dividirPrecio: true,
        }
        this.getPrecios()
        this.getZonas()
    }
    componentDidMount(){
        const today = new Date();
        const date = today.toISOString().substr(0, 10)
        const assignedTask = { ...this.state.assignedTask }
        assignedTask["fechaInicio"] = today
        assignedTask["fechaEntrega"] = today
        this.setState({ fechaInicioStr: date, fechaEntregaStr: date, assignedTask: assignedTask})
    }
    componentDidUpdate(prevProps, prevState) {
        if (
            this.state.precioUnaPersona !== prevState.precioUnaPersona ||
            this.state.assignedTask.nomina !== prevState.assignedTask.nomina ||
            this.state.assignedTask.empleados !== prevState.assignedTask.empleados
        ) {
            this.getUnitPrice()
        }
        if (
            this.state.subTasksList !== prevState.subTasksList ||
            this.state.assignedTask.precioUnitario !== prevState.assignedTask.precioUnitario ||
            this.state.assignedTask.longitudTrabajo !== prevState.assignedTask.longitudTrabajo
        ) {
            this.UpdatePrices()
        }
        if (
            this.state.subTasksList !== prevState.subTasksList
        ) {
            this.getAreaLength()
        }
        if(this.state.zones!==prevState.zones){
            this.getTuneles()
        }
    }
    handleSubmit = event => {
        event.preventDefault()
        this.setState({ submitDisabled: true })
        if (!this.validateSubmit()) {
            this.setState({ submitDisabled: false })
            return null
        }
        const isCompleted = this.isTaskCompleted()
        const status = isCompleted ? 'asignado' : 'pendiente'
        const assignedTask = this.state.assignedTask
        const assignedArea = this.state.subTasksList.toString()
        const completedArea = (this.state.completedArea !== '' && this.state.completedArea)
            ? this.state.completedArea + ',' + assignedArea
            : assignedArea
        assignedTask.areaAsignada = assignedArea
        assignedTask.tareaId = this.tareaId
        assignedTask.nombreActividad = this.actividad
        if (assignedTask.unidad === 'cajas') {
            assignedTask.cajas6 = 0
            assignedTask.cajas6Precio = this.state.precioUnaPersona
        }
        const batch = firebase.firestore().batch()
        const asignadas = firebase.firestore().collection('TareasAsignadas')
        const pendientes = firebase.firestore().collection('Tareas')
        batch.update(pendientes.doc(this.tareaId), {
            lugarCompletado: completedArea,
            status: status,
        })
        if (assignedTask.unidad === 'cajas' || assignedTask.unidad === 'botes') {
            for (let i = 0; i < assignedTask.empleados.length; i++) {
                let task = { ...assignedTask }
                task.empleados = [assignedTask.empleados[i]]
                batch.set(asignadas.doc(), task)
            }
        }
        else
            batch.set(asignadas.doc(), this.state.assignedTask)
        batch.commit()
            .then(() => {
                alert('todo ok')
            })
            .catch(e => {
                console.log(e)
                alert(e.message)
            })
    }
    handleChange = (e, { value }) => {
        const empleados = value
        const assignedTask = { ...this.state.assignedTask }
        assignedTask.empleados = empleados
        this.setState({
            assignedTask: assignedTask
        })
    }
    handleDateChange = (e, { name, value }) => {
        const fecha = DateUtilities.parseDate(value)
        const assignedTask = { ...this.state.assignedTask }
        assignedTask[name] = fecha
        this.setState({
            assignedTask: assignedTask,
            [`${name}Str`]: value,
        })
    }
    UpdatePrices = () => {
        const precio = this.cotizarActividad()
        const assignedTask = { ...this.state.assignedTask }
        assignedTask.precioTotal = precio
        this.setState({ assignedTask })
    }
    toggleCode = (code) => {
        const index = this.state.subTasksList.indexOf(code)
        let { zonasAsignadas, tunelesAsigadas, camasAsignadas } = { ...this.state }
        const subTasksList = [...this.state.subTasksList]
        //const assignedTask = { ...this.state.assignedTask }
        const delta = index === -1 ? 1 : -1
        if (delta > 0)
            subTasksList.push(code)
        else
            subTasksList.splice(index, 1)
        const asignadas = this.handleAssignCounters(this.state.assignBy, zonasAsignadas, tunelesAsigadas, camasAsignadas, delta)
        zonasAsignadas = asignadas.zonasAsignadas
        tunelesAsigadas = asignadas.tunelesAsigadas
        camasAsignadas = asignadas.camasAsignadas
        this.setState({
            zonasAsignadas,
            tunelesAsigadas,
            camasAsignadas,
            subTasksList,
        })
        return delta > 0
    }
    handleAssignCounters(assignBy, zonasAsignadas, tunelesAsigadas, camasAsignadas, delta) {
        if (assignBy === 'zona') {
            zonasAsignadas += delta
        }
        else if (assignBy === 'tunel') {
            tunelesAsigadas += delta
        }
        else {
            camasAsignadas += delta
        }
        return { zonasAsignadas, tunelesAsigadas, camasAsignadas }
    }
    isCamaFinished = (zona, codeTunel, cama) => {
        const result =
            this.state.disabledArea.includes(`${codeTunel}-${cama}`) ||
            this.state.disabledArea.includes(codeTunel + '-x') ||
            this.state.disabledArea.includes(zona + '/x-x') ||
            this.state.subTasksList.includes(`${codeTunel}-${cama}`) ||
            this.state.subTasksList.includes(codeTunel) ||
            this.state.subTasksList.includes(zona)
        return result
    }
    isTaskCompleted = () => {
        for (let i = 0; i < this.state.tuneles.length; i++) {
            const tunel = this.state.tuneles[i]
            for (let j = 0; j < tunel.num; j++) {
                const codeTunel = `${tunel.zone}/${j + 1}`
                if (!this.isCamaFinished(tunel.zone, codeTunel, 'a'))
                    return false
                if (!this.isCamaFinished(tunel.zone, codeTunel, 'b'))
                    return false
                if (!this.isCamaFinished(tunel.zone, codeTunel, 'c'))
                    return false
            }
        }
        return true
    }
    getUnitPrice = () => {
        const assignedTask = { ...this.state.assignedTask }
        if (this.state.assignedTask.nomina === 'hora') {
            assignedTask.precioUnitario = 0
            this.setState({ assignedTask })
            return
        }
        const numPersonas = this.state.assignedTask.empleados.length > 0 ? this.state.assignedTask.empleados.length : 1
        const unitPrice = this.state.assignedTask.unidad !== 'cajas'
        //const unitPrice = this.state.dividirPrecio
            ?
            +(this.state.precioUnaPersona / numPersonas).toFixed(2)
            :
            +(this.state.precioUnaPersona).toFixed(2)
        assignedTask.precioUnitario = unitPrice
        this.setState({ assignedTask })
    }
    handlePaymentType = (e, { value }) => {
        const assignedTask = { ...this.state.assignedTask }
        assignedTask.nomina = value
        this.setState({
            assignedTask
        })
    }
    handleRectClick = (code, id) => {
        const rect = document.getElementById(id)
        rect.style.backgroundColor = this.toggleCode(code) ? 'lightblue' : 'white'
    }
    handleChangeDrop = (e, { value }) => {
        const assignedTask = { ...this.state.assignedTask }
        assignedTask.longitudTrabajo = 0
        assignedTask.precioTotal = 0
        this.setState({
            assignBy: value,
            subTasksList: [],
            assignedTask,
        })
    }
    handleDif = (value) => {
        this.setState({
            precioUnaPersona: Number(value),
        })
    }
    getAreaLength = () => {
        const areaAsignada = this.state.subTasksList
        const tuneles = this.state.tunelesMedidas
        let metrosTrabajados = 0
        if (this.state.assignedTask.unidad !== 'metros') return 0
        for (let i = 0; i < areaAsignada.length; i++) {
            const areaTokens = areaAsignada[i].split('/')
            if (areaTokens.length > 1) {
                const tunelTokens = areaTokens[1].split('-')
                if (tunelTokens.length > 1) {
                    metrosTrabajados += (tuneles[areaTokens[0]][tunelTokens[0] - 1]) / 3
                }
                else {
                    metrosTrabajados += (tuneles[areaTokens[0]][tunelTokens[0] - 1])
                }
            }
            else {
                tuneles[areaTokens[0]].forEach(tunel => {
                    metrosTrabajados += tunel
                })
            }
        }
        const assignedTask = { ...this.state.assignedTask }
        assignedTask.longitudTrabajo = +metrosTrabajados.toFixed(2)
        this.setState({ assignedTask })
    }
    cotizarActividad = () => {
        const metrosTrabajados = this.state.assignedTask.longitudTrabajo
        const precioUnitario = this.state.assignedTask.precioUnitario
        if (this.state.assignedTask.unidad !== 'metros')
            return 0
        return +(metrosTrabajados * precioUnitario).toFixed(2)
    }
    getPrecios = () => {
        firebase.firestore().collection('Actividades').where('nombre', '==', this.actividad).get()
        .then(snap => {
            snap.forEach(doc => {
                if (doc.exists) {
                    const precioInicial = doc.data().nombre !== 'Piscar Zarzamora'
                        ?
                        doc.data().precioMin
                        :
                        doc.data().caja6[0]
                    this.setState({
                        precioInicial,
                        precioUnaPersona: precioInicial
                    })
                }
            })
        })
    }
    getZonas = () => {
        firebase.firestore().collection('Tareas').doc(this.tareaId).get()
            .then(doc => {
                const pendingArea=doc.data().lugarPendiente
                const completedArea=doc.data().lugarCompletado
                let zonasAsignadas = this.state.zonasAsignadas
                let tunelesAsigadas = this.state.tunelesAsigadas
                let camasAsignadas = this.state.camasAsignadas
                if (this.state.pendingArea === undefined && this.state.pendingArea === '') return null
                const disabledArea = this.state.disabledArea
                const zones = []
                const required = []
                const pendingTokens = pendingArea.split(',')
                //Este sector agrega a required Area las áreas que son requeridas en una tarea
                for (let j = 0; j < pendingTokens.length; j++) {
                    const zoneTokens = pendingTokens[j].split('/')
                    if (zones.indexOf(zoneTokens[0]) === -1)
                        zones.push(zoneTokens[0])
                    if (required.indexOf(zoneTokens[0]) === -1 && zoneTokens.length === 1) {
                        required.push(zoneTokens[0])
                    }
                    if (zoneTokens.length > 1) {
                        const codeTunel = `${zoneTokens[0]}/${zoneTokens[1]}`
                        if (required.indexOf(codeTunel) === -1)
                            required.push(codeTunel)
                    }
                }
                //Completed area sirve para añadir a disabled area las zonas, tuneles o camas que ya han sido completados así como
                //areas hijas. Una x en el código de área significa todas
                if (completedArea !== undefined && completedArea !== '') {
                    const areaTokens = completedArea.split(',')
                    for (let i = 0; i < areaTokens.length; i++) {
                        const zoneTokens = areaTokens[i].split('/')
                        if (zoneTokens.length > 1) {
                            if (disabledArea.indexOf(zoneTokens[0]) === -1)
                                disabledArea.push(zoneTokens[0])
                            const tunelTokens = zoneTokens[1].split('-')
                            if (tunelTokens.length > 1) {
                                camasAsignadas++
                                const tunelToken = `${zoneTokens[0]}/${tunelTokens[0]}`
                                if (this.state.disabledArea.indexOf(tunelToken) === -1)
                                    disabledArea.push(tunelToken)
                                disabledArea.push(areaTokens[i])
                            }
                            else {
                                tunelesAsigadas++
                                disabledArea.push(`${zoneTokens[0]}/${tunelTokens[0]}`)
                                disabledArea.push(`${zoneTokens[0]}/${tunelTokens[0]}-x`)
                            }
                        }
                        else {
                            zonasAsignadas++
                            disabledArea.push(zoneTokens[0])
                            disabledArea.push(zoneTokens[0] + '/x-x')
                        }
                    }
                }
                this.setState({
                    disabledArea: disabledArea,
                    zones: zones,
                    requiredArea: required,
                    zonasAsignadas: zonasAsignadas,
                    tunelesAsigadas: tunelesAsigadas,
                    camasAsignadas: camasAsignadas,
                    pendingArea,
                    completedArea,
                })
            })
    }
    getTuneles = () => {
        this.state.zones.forEach(zone => {
            firebase.firestore().collection('Zonas').where('sector', '==', parseInt(zone)).get()
                .then(snap => {
                    snap.forEach(doc => {
                        if (!doc.exists) return null
                        const tuneles = this.state.tuneles
                        doc.data()
                        if (!doc.data().tuneles) return null
                        tuneles.push({ num: doc.data().tuneles.length, zone: zone })
                        const tunelesMedidas = this.state.tunelesMedidas
                        tunelesMedidas[zone] = doc.data().tuneles
                        this.setState({
                            tuneles: tuneles,
                            tunelesMedidas: tunelesMedidas
                        })
                    })
                })
        })
    }
    validateSubmit = () => {
        let pass = true
        let mensajes = this.state.mensajes
        if (this.state.assignedTask.empleados.length === 0) {
            pass = false
            mensajes.empleados = true
        }
        else {
            mensajes.empleados = false
        }
        if (this.state.subTasksList.length === 0) {
            pass = false
            mensajes.area = true
        }
        else {
            mensajes.area = false
        }
        if (this.state.assignedTask.fechaInicio === '') {
            pass = false
            mensajes.fechaInicio = true
        }
        if (this.state.assignedTask.fechaEntrega === '') {
            pass = false
            mensajes.fechaEntrega = true
        }
        this.setState({ mensajes: mensajes })
        return pass
    }
    validateZona = (zona) => {
        return this.state.disabledArea.indexOf(zona) === -1 && this.state.requiredArea.indexOf(zona) !== -1
    }
    renderZonas = () => {
        return this.state.zones.map(zone => {
            if (this.validateZona(zone)) {
                return (
                    <div key={zone} id={Styles.Zona + zone} className={Styles.Zona} onClick={() => { this.handleRectClick(zone, Styles.Zona + zone) }}>
                        <p>{zone}</p>
                    </div>
                )
            }
            return (
                <div key={zone} className={Styles.DisabledZone}>
                    <p>{zone}</p>
                </div>
            )
        })
    }
    validateTunel = (zona, code) => {
        return this.state.disabledArea.indexOf(code) === -1 && this.state.disabledArea.indexOf(zona + '/x-x') === -1 && (this.state.requiredArea.indexOf(zona) !== -1 || this.state.requiredArea.indexOf(code) !== -1)
    }
    renderTuneles = () => {
        return (
            <div className={Styles.Tuneles}>
                {
                    this.state.tuneles.map(tunel => {
                        const elements = []
                        for (let i = 0; i < tunel.num; i++) {
                            const code = `${tunel.zone}/${i + 1}`
                            if (this.validateTunel(tunel.zone, code)) {
                                elements.push(
                                    <div key={code} id={Styles.Tunel + code} className={Styles.Tunel} onClick={() => { this.handleRectClick(code, Styles.Tunel + code) }}><p>{code}</p></div>
                                )
                                continue
                            }
                            elements.push(
                                <div key={code} className={Styles.DisabledTunel}><p>{code}</p></div>
                            )
                        }
                        return elements
                    })
                }
            </div>
        )
    }
    validateCama = (zona, codeTunel, cama) => {
        return this.state.disabledArea.indexOf(`${codeTunel}-${cama}`) === -1
            && this.state.disabledArea.indexOf(codeTunel + '-x') === -1
            && this.state.disabledArea.indexOf(zona + '/x-x') === -1
            && (this.state.requiredArea.indexOf(codeTunel) !== -1 || this.state.requiredArea.indexOf(zona) !== -1)
    }
    renderCamas = () => {
        return (
            <div className={Styles.Camas}>
                {
                    this.state.tuneles.map(tunel => {
                        const elements = []
                        for (let i = 0; i < tunel.num; i++) {
                            const codeTunel = `${tunel.zone}/${i + 1}`
                            elements.push(
                                <div className={Styles.TunelCamas} key={codeTunel}>
                                    {this.validateCama(tunel.zone, codeTunel, 'a') ?
                                        <div key={codeTunel + '-a'} id={Styles.Cama + codeTunel + '-a'} className={Styles.Cama} onClick={() => { this.handleRectClick(codeTunel + '-a', Styles.Cama + codeTunel + '-a') }}><p>{codeTunel + '-a'}</p></div>
                                        : <div className={Styles.DisabledCama}><p>{codeTunel + '-a'}</p></div>
                                    }
                                    {this.validateCama(tunel.zone, codeTunel, 'b') ?
                                        <div key={codeTunel + '-b'} id={Styles.Cama + codeTunel + '-b'} className={Styles.Cama} onClick={() => { this.handleRectClick(codeTunel + '-b', Styles.Cama + codeTunel + '-b') }}><p>{codeTunel + '-b'}</p></div>
                                        : <div className={Styles.DisabledCama}><p>{codeTunel + '-b'}</p></div>
                                    }
                                    {this.validateCama(tunel.zone, codeTunel, 'c') ?
                                        <div key={codeTunel + '-c'} id={Styles.Cama + codeTunel + '-c'} className={Styles.Cama} onClick={() => { this.handleRectClick(codeTunel + '-c', Styles.Cama + codeTunel + '-c') }}><p>{codeTunel + 'c'}</p></div>
                                        : <div className={Styles.DisabledCama}><p>{codeTunel + 'c'}</p></div>
                                    }
                                </div>
                            )
                        }
                        return elements
                    })
                }
            </div>
        )
    }
    render() {
        return (
            <section>
                <Form onSubmit={this.handleSubmit}>
                    <div className={Styles.Inputs}>
                        <div className={Styles.Input}>
                            <p>Asignar área por:</p>
                            <Dropdown
                                fluid
                                selection
                                options={[{ key: 1, value: 'zona', text: 'Por Zona' }, { key: 2, value: 'tunel', text: 'Por Tunel' }, { key: 3, value: 'cama', text: 'Por cama' }]}
                                placeholder='Asignar por...'
                                onChange={this.handleChangeDrop}
                                value={this.state.assignBy}
                            />
                        </div>
                        <div className={Styles.Input}>
                            <p>Empleados:</p>
                            <MultipleFS search 
                            filtro1= 'activo'
                            filtro2 = '!=' 
                            filtro3 = 'no'
                            tabla='Empleados' 
                            columna='Nombre' 
                            onChange={this.handleChange} 
                            name='empleados' />
                            {
                                this.state.mensajes.empleados ?
                                    <p className={Styles.message}>Campo Obligatorio</p>
                                    : null
                            }
                        </div>
                        {
                            this.actividad === 'Piscar Zarzamora' || this.actividad === 'Piscar Frambuesa'
                                ?
                                null
                                :
                                <div className={Styles.Input}>
                                    <p>Precio Unitario</p>
                                    <PointedBar
                                        initial={this.state.precioInicial}
                                        handleChange={this.handleDif}
                                    />
                                </div>
                        }
                        <div className={Styles.Input}>
                            <p>Pagar por</p>
                            <Dropdown
                                fluid
                                selection
                                placeholder='Seleccione dificultad'
                                onChange={this.handlePaymentType}
                                value={this.state.assignedTask.nomina}
                                options={[{ key: 1, value: 'tarea', text: 'Tarea' }, { key: 2, value: 'hora', text: 'Dia' }]}
                            />
                        </div>
                        <div className={Styles.Input}>
                            <p>Fecha Inicio: </p>
                            <Input type='date' name='fechaInicio' 
                            onChange={this.handleDateChange} 
                            value={this.state.fechaInicioStr} />
                            {
                                this.state.mensajes.fechaInicio ?
                                    <p className={Styles.message}>Campo Obligatorio</p>
                                    : null
                            }
                        </div>
                        <div className={Styles.Input}>
                            <p>Fecha Entrega: </p>
                            <Input type='date' name='fechaEntrega' 
                            onChange={this.handleDateChange} 
                            value={this.state.fechaEntregaStr} />
                            {
                                this.state.mensajes.fechaEntrega ?
                                    <p className={Styles.message}>Campo Obligatorio</p>
                                    : null
                            }
                        </div>
                        <div className={Styles.Input}>
                            <p>Área seleccionada:</p>
                            <table>
                                <thead>
                                    <tr>
                                        <th>Zona</th>
                                        <th>Tunel</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.subTasksList.map((item, index) => {
                                        const values = item.split('/');
                                        return (
                                            <tr key={index}>
                                                <td>{values[0]}</td>
                                                <td>{values[1]}</td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                            {
                                this.state.mensajes.area ?
                                    <p className={Styles.message}>Campo Obligatorio</p>
                                    : null
                            }
                        </div>
                        {
                            (() => {
                                switch (this.state.assignedTask.unidad) {
                                    case 'metros':
                                        return (
                                            <div className={Styles.Input}>
                                                <p>A pagar por persona</p>
                                                <p>${this.state.assignedTask.precioTotal}</p>
                                            </div>
                                        )
                                    case 'unidades':
                                        return (
                                            <div className={Styles.Input}>
                                                <p>A pagar por unidad</p>
                                                <p>${this.state.assignedTask.precioUnitario}</p>
                                            </div>
                                        )
                                    case 'botes':
                                        return (
                                            <div className={Styles.Input}>
                                                <p>A pagar por bote</p>
                                                <p>${this.state.assignedTask.precioUnitario}</p>
                                            </div>
                                        )
                                    case 'cajas':
                                        return (
                                            <div className={Styles.Input}>
                                                <p>Precios</p>
                                                <Input
                                                    className={Styles.boxPrices}
                                                    label='Precio medio bote'
                                                    value={this.state.assignedTask.precioUnitario/4}
                                                    disabled>
                                                </Input>
                                            </div>
                                        )
                                }
                            })()
                        }
                        {
                            this.state.assignedTask.unidad === 'metros' ?
                                <div className={Styles.Input}>
                                    <p>Metros a trabajar</p>
                                    <p>{this.state.assignedTask.longitudTrabajo}m</p>
                                </div>
                                : null
                        }

                    </div>
                    <Button type='submit' disabled={this.state.submitDisabled}>Asignar</Button>
                    <br />
                    <br />
                    {this.state.assignBy === 'zona' ?
                        this.renderZonas()
                        : null
                    }
                    {this.state.assignBy === 'tunel' ?
                        this.renderTuneles()
                        : null
                    }
                    {this.state.assignBy === 'cama' ?
                        this.renderCamas()
                        : null
                    }
                </Form>
            </section>
        )
    }
}

export default AsignarTrabajo